import React from 'react';

/**
 * Build the mirror-badge tooltip content from a mirror category's
 * `mirroredFromInfo` field + the KNOWLEDGE_CATEGORY lang block.
 *
 * - Without path data (viewer lacks access to the source workspace) → type-aware
 *   generic ("Mirrored from another section/folder/binder").
 * - Full info → "Mirrored from: {workspace} / a / b / c" with the topmost
 *   mirror's source segment (at `mirrorRootIndex`) bolded.
 *
 * @param {{
 *   sourceCategoryType: 'section' | 'folder' | 'binder',
 *   workspaceName?: string,
 *   pathTitles?: string[],
 *   mirrorRootIndex?: number,
 * }} mirroredFromInfo
 * @param {object} lang - the KNOWLEDGE_CATEGORY lang block
 * @returns {React.ReactNode}
 */
export function buildMirrorTooltip(mirroredFromInfo, lang) {
  if (!mirroredFromInfo) {
    return null;
  }

  const { sourceCategoryType, workspaceName, pathTitles, mirrorRootIndex } = mirroredFromInfo;

  if (!pathTitles) {
    return lang[`MIRRORED_${sourceCategoryType.toUpperCase()}`];
  }

  return (
    <>
      {lang.MIRRORED_FROM_PATH_PREFIX} {workspaceName}
      {pathTitles.map((title, i) => (
        <React.Fragment key={i}>
          {' / '}
          {i === mirrorRootIndex ? <strong>{title}</strong> : title}
        </React.Fragment>
      ))}
    </>
  );
}
